import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'


const state = {
  userID: 0,
  userName: '',
  permissions: [],
  isLoggedIn: false,
  pending: true,
  disabled: false
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/login/index.js